<kodit-page>
  <kodit-table
    [tableConfig]="tableConfig"
    [chipItems]="chipItems"
    [paginatedData]="paginatedData"
  >
  </kodit-table>
</kodit-page>

